import { useState, useCallback } from "react";

interface UseUnsavedChangesProps {
  currentData: any;
  originalData: any;
}

export const useUnsavedChanges = ({
  currentData,
  originalData,
}: UseUnsavedChangesProps) => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const hasUnsavedChanges = useCallback((): boolean => {
    return JSON.stringify(currentData) !== JSON.stringify(originalData);
  }, [currentData, originalData]);

  const handleOpenConfirmDialog = useCallback(() => {
    if (hasUnsavedChanges()) {
      setOpenConfirmDialog(true);
      return true;
    }
    return false;
  }, [hasUnsavedChanges]);

  const handleCloseConfirmDialog = useCallback(() => {
    setOpenConfirmDialog(false);
  }, []);

  return {
    openConfirmDialog,
    setOpenConfirmDialog,
    hasUnsavedChanges,
    handleOpenConfirmDialog,
    handleCloseConfirmDialog,
  };
};
